import { render, staticRenderFns } from "./SMSOld.vue?vue&type=template&id=7a18b786&"
import script from "./SMSOld.vue?vue&type=script&lang=js&"
export * from "./SMSOld.vue?vue&type=script&lang=js&"
import style0 from "./SMSOld.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports